<template>
  <div>
    <section>
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;padding-top: 10px">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <el-form-item>
            <el-input v-model="searchText" placeholder="硬件码 / 备注" style="width:200px;" @keyup.enter.native="getList(1)"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" v-on:click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="handleAdd" class="adds">新增</el-button>
          </el-form-item>

          <el-form-item>
            <el-button type="text" class="adds"><label for="uploadwxsModal">导入</label></el-button>
          </el-form-item> 

          <input
              type="file"
              id="uploadwxsModal"
              style="display:none"
              name="file"
              ref="clearFileModal"
              @change="importFile($event)"
            />

          <el-form-item>
            <a :href="hrefUrl"><el-button type="text" class="adds">下载模板</el-button></a>
          </el-form-item> 

        </el-form>
      </el-col>

      <!--列表-->
      <el-table tooltip-effect="dark" :data="proList" highlight-current-row v-loading="listLoading" style="width: 100%;" 
        @selection-change="selsChange" :header-cell-style="getRowClass" @sort-change="handleSortChange">
        <el-table-column type="index" :index="indexMethod" label="序号" width="100">
          <template slot-scope="scope">
              <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="hardHash" label="设备硬件码" min-width="240" sortable="custom" show-overflow-tooltip >
        </el-table-column>
        <el-table-column prop="comment" label="备注" min-width="300" sortable="custom" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.comment || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deptname" label="部门" min-width="300" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="intime" label="添加时间" min-width="140" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        
        <el-table-column label="操作" min-width="120" style="text-algin:center">
          <template slot-scope="scope">
             <span class="operate">
                <el-tooltip effect="dark" content="编辑" placement="top" >
                  <span class="dnnfont iconEdit"  @click="handleEdit(scope.$index, scope.row)"></span>
                </el-tooltip>

                <el-tooltip effect="dark" content="删除" placement="top" v-if="!scope.row.delShow">
                    <span class="dnnfont icondelete"  @click="handleDel(scope.$index, scope.row)"></span>
                </el-tooltip>
              </span>
            <!-- <el-button type="primary" plain size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="danger" plain size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:10px; padding-bottom: 10px">
        <el-pagination 
          layout="sizes, prev, pager, next"
          :page-sizes="[10, 20, 30, 50,100]"
          :current-page="pageNumber" 
          @current-change="handleCurrentChange" 
          @size-change="handleSizeChange"
          :page-size="pageSize"
          :total="total" 
          style="float:right;">
        </el-pagination>
      </el-col>

      <!--新增界面-->
      <el-dialog class="model-edit" title="新增设备" :visible.sync="addFormVisible" 
        :close-on-click-modal="false">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-row>
            <el-col :span="22"> 
              <el-form-item label="硬件码" prop="hardHash">
                <el-input v-model="addForm.hardHash" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22"> 
              <el-form-item label="部门" > 
                <el-input  v-model="addForm.deptname" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22"> 
              <el-form-item label="备注" prop="comment"> 
                <el-input type="textarea" :rows="4" v-model="addForm.comment" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--编辑界面-->
      <el-dialog class="model-edit" title="编辑设备" :visible.sync="editFormVisible" 
        :close-on-click-modal="false">
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
          <el-row>
            <el-col :span="22"> 
              <el-form-item label="硬件码" prop="hardHash">
                <el-input v-model="editForm.hardHash" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22"> 
              <el-form-item label="部门" > 
                <el-input  v-model="editForm.deptname" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22"> 
              <el-form-item label="备注" prop="comment"> 
                <el-input type="textarea" :rows="4" v-model="editForm.comment" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

    </section>
  </div>
</template>
<script>
import { API__code,API_userCom} from '../../../api/index.js'
import $ from 'jquery'
import cookie from "js-cookie";

export default {
  inject:['reload'],
  data(){
    return{
      searchText: '',
      companymanageid:'',//企业id
      souchs:{
        hardHash:'',
        comment:'',
        deptname:'',
      },
      dynamicTags:[],
      proName:'',
      options: [
        {value: '硬件码',label: '硬件码'}, 
        {value: '备注',label: '备注'},
        {value: '部门',label: '部门'},
      ],
      value:"",
      token:'',
      checkCode:'',
      id:'',
      total:1,
      pageSize: 20,
      pageNumber:1,
      proList:[],
      listLoading:false,
      sels:[],
      addFormVisible:false,
      addForm:{
        hardHash:'',
        comment:'',
        deptname:'',
      },
      addLoading:false,
      addFormRules:{
        hardHash: [
          { required: true, message: '请输入硬件码', trigger: 'blur' }
        ]
      },
      editFormVisible:false,
      editForm:{
        hardHash:'',
        comment:'',
        deptname:'',
      },
      editLoading:false,
      editFormRules:{
        hardHash: [
          { required: true, message: '请输入硬件码', trigger: 'blur' }
        ],
        deptname:[
          { required: true, message: '请输入部门', trigger: 'blur' }
        ]
      },
      orderType:'',
      orderStr:'',
      hrefUrl:'',
    }
  },
  methods:{
    importFile(filex) {
      var file = filex.target.files[0];
      var formData = new FormData();
      formData.append('file',file);
      if(!file){
        _this.$message.error('请选择文件！');
        return;
      }
      var _this = this;
      _this.listLoading = true;
      $.ajax({
        url: API_userCom.companyBatchAdd()+"?companyid="+this.$route.query.companyId+""+'&checkCode='+ cookie.get("dnnyptadmin_checkCode")+'&token='+ cookie.get("dnnyptadmin_token"),
        type: "POST",
        data: formData,
        processData: false,
        contentType: false,
        dataType: "json",
        timeout: 180000,
        success: function(res) {
          if(res.code==200){
            _this.$message.success('导入成功！');
          }else{
            _this.$message.error(res.message);
          }
          _this.getList();
          _this.$refs.clearFileModal.value = "";
        },
        error: function(err) {
          _this.$message.error(res.message);
          _this.listLoading = false;
        },
        complete: function() {}
      });
        
    },
    handleSortChange:function(val){
      if(val){
        if(val.prop == "hardHash"){
          this.orderStr = "hardHashpx";
        }else if(val.prop == "comment"){
          this.orderStr = "commentpx";
        }else if(val.prop == "deptname"){
          this.orderStr = "deptnamepx";
        }else if(val.prop == "intime"){
          this.orderStr = "intimepx";
        }
        if(val.order == "descending"){
          this.orderType = "desc";
        }else{
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch:function(val){
      if(val == "硬件码"){
        this.proName = this.souchs.hardHash;
      }else if(val == "备注"){
        this.proName = this.souchs.comment;
      }else if(val == "部门"){
        this.proName = this.souchs.deptname;
      }
    },
    delTags:function(){
      this.souchs = {},
      this.value = '';
      this.proName = '';
      this.dynamicTags = [];
      this.getList();
    },
    handleClose(tag) {
      if(tag == "硬件码"){
        this.souchs.hardHash ="";
        if(this.value == "硬件码"){
          this.proName = '';
        }
      }
      if(tag == "部门"){
        this.souchs.deptname ="";
        if(this.value == "部门"){
          this.proName = '';
        }
      }
      if(tag == "备注"){
        this.souchs.comment ="";
        if(this.value == "备注"){
          this.proName = '';
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    editSubmit:function(){
      if(!this.editForm.hardHash){
        this.$message.error('硬件码不可为空！');
        return;
      }
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        mode:'',
        id:this.editForm.id,
        comment:this.editForm.comment,
        hardHash:this.editForm.hardHash,
        deptname:this.editForm.deptname,
        // companyid:this.companymanageid,
        companyid:this.$route.query.companyId,
      }
      this.editLoading = true;
      API_userCom.addSBList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: "保存成功",
            type: 'success'
          });
          this.getList();
          this.editFormVisible = false;
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
        this.editLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.editLoading = false;
      })
    },
    addSubmit:function(){
      if(!this.addForm.hardHash){
        this.$message.error('硬件码不可为空！');
        return;
      }
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        mode:'save',
        comment:this.addForm.comment,
        hardHash:this.addForm.hardHash,
        deptname:this.addForm.deptname,
        // companyid:this.companymanageid,
        companyid:this.$route.query.companyId,
      }
      this.addLoading = true;
      API_userCom.addSBList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: "保存成功",
            type: 'success'
          });
          this.getList();
          this.addFormVisible = false;
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
        this.addLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.addLoading = false;
      })
    },
    handleDel:function(index,row){
      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let param = {
          token:this.token,
          checkCode:this.checkCode,
          id:row.id,
        }
        API_userCom.delSBList(param)
        .then((res) =>{
          if(res.data.code == API__code.SUCCESS){
            this.$message({
              message: "删除成功",
              type: 'success'
            });
            this.getList();
          }else{
            this.$message.error(res.data.message);
            if(res.data.code == 403){
              this.$router.push({path: 'login'});
            }
          }
        }).catch(err =>{
          this.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(err =>{
      });
    },
    handleEdit:function(index,row){
      this.editForm = Object.assign({}, row);
      this.editFormVisible = true;
    },
    handleAdd:function(){
      this.addForm = {};
      this.addFormVisible = true;
    },
    getList:function(val){
      if(this.value == "硬件码"){
        this.souchs.hardHash = this.proName;
      }
      if(this.value == "部门"){
        this.souchs.deptname = this.proName;
      }
      if(this.value == "备注"){
        this.souchs.comment = this.proName;
      }
      var flag = true;
      if(val == 1){
        if(this.value){
          if(this.dynamicTags.length > 0){
            for(var i=0;i<this.dynamicTags.length;i++){
              if(this.value == this.dynamicTags[i]){
                flag = false;
              }
            }
          }
          if(flag){
            this.dynamicTags.push(this.value);
          }
        }
      }
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        listType: 'page',
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        // companyid:sessionStorage.getItem('companymanageid'),
        // companyid:this.companymanageid,
        companyid:this.$route.query.companyId,
        comment:this.souchs.comment,
        hardHash:this.souchs.hardHash,
        deptname:this.souchs.deptname,
        orderType:this.orderType,
        orderStr:this.orderStr,
        searchText: this.searchText
      }
      this.listLoading = true;
      API_userCom.getSBList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.list){
            this.proList = res.data.data.list;
            if(res.data.data.totalRow){
              this.total = res.data.data.totalRow;
            }
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
        this.listLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.listLoading = false;
      });
    },
    indexMethod(index) {
      return (index+1)+(this.pageNumber-1)*pageSize;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    handleSizeChange(val) {
			this.pageSize = val;
			this.getList();
		},
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnyptadmin_token') {
              this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
              this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
              this.id = arr2[1];
          }
        }
      }
    },
  },
  mounted(){
    this.getList();
  },
  created(){
    this.getCookie();
    this.hrefUrl = API_userCom.companyTemplate()
  }
}
</script>
<style scoped>
.el-select {
    display: inline-block;
    position: relative;
    width: 115px;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
.float_left{
	float: left;
}
</style>




// WEBPACK FOOTER //
// Device.vue?ff6ad6c8